/* ag-chat.js — widget de chat de atención al cliente. Vanilla JS, sin dependencias. */
(function () {
  'use strict';

  var root = document.getElementById('ag-chat');
  if (!root) return;
  if (root.dataset.agChatInitialized === 'true') return;

  var endpoint = root.dataset.endpoint;
  var fab = root.querySelector('.ag-chat__fab');
  var panel = root.querySelector('.ag-chat__panel');
  var cerrar = root.querySelector('.ag-chat__cerrar');
  var log = root.querySelector('.ag-chat__log');
  var sugerencias = root.querySelector('.ag-chat__sugerencias');
  var form = root.querySelector('.ag-chat__form');
  var input = root.querySelector('.ag-chat__input');
  var enviarBtn = root.querySelector('.ag-chat__enviar');
  if (!endpoint || !fab || !panel || !cerrar || !log || !form || !input || !enviarBtn) return;
  root.dataset.agChatInitialized = 'true';

  var HISTORY_KEY = 'ag-chat-history';
  var OPEN_KEY = 'ag-chat-open';
  var MAX_HISTORY = 16;

  var history = [];
  var enviando = false;

  function safeGet(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function safeSet(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (e) {
      /* almacenamiento no disponible, seguimos sin persistir */
    }
  }

  function loadHistory() {
    var raw = safeGet(HISTORY_KEY);
    if (!raw) return;
    try {
      var parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        history = parsed.slice(-MAX_HISTORY).filter(function (t) {
          return t && (t.role === 'user' || t.role === 'assistant') && typeof t.content === 'string';
        });
      }
    } catch (e) {
      history = [];
    }
  }

  function saveHistory() {
    history = history.slice(-MAX_HISTORY);
    safeSet(HISTORY_KEY, JSON.stringify(history));
  }

  function repintarHistorial() {
    history.forEach(function (turno) {
      pintarMensaje(turno.role === 'user' ? 'user' : 'bot', turno.content);
    });
  }

  // ---- Render seguro de markdown ----
  function escapeHtml(text) {
    return text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function urlPermitida(url) {
    return (
      url.indexOf('https://agranelmadrid.com/') === 0 ||
      url.indexOf('/products/') === 0 ||
      url.indexOf('/pages/') === 0 ||
      url.indexOf('/blogs/') === 0 ||
      url.indexOf('/collections/') === 0 ||
      url.indexOf('mailto:') === 0 ||
      url.indexOf('tel:') === 0 ||
      url.indexOf('https://wa.me/') === 0
    );
  }

  // Los enlaces de la tienda se abren en la misma pestaña: el historial vive en sessionStorage
  // y una pestaña nueva empezaría con el chat vacío. WhatsApp, correo y teléfono salen fuera.
  function esInterna(url) {
    return url.indexOf('https://agranelmadrid.com/') === 0 || url.charAt(0) === '/';
  }

  function attrsEnlace(url) {
    return esInterna(url) ? '' : ' target="_blank" rel="noopener"';
  }

  function renderMarkdown(text) {
    var escaped = escapeHtml(text || '');

    // Enlaces [texto](url)
    escaped = escaped.replace(/\[([^\]]+)\]\(([^)]+)\)/g, function (match, label, url) {
      return urlPermitida(url) ? '<a href="' + url + '"' + attrsEnlace(url) + '>' + label + '</a>' : label;
    });

    // URLs sueltas permitidas (sin el punto o la coma final de la frase)
    escaped = escaped.replace(/(^|[\s(])((https?:\/\/agranelmadrid\.com\/|https:\/\/wa\.me\/)[^\s<)]*[^\s<).,;:])/g, function (match, pre, url) {
      return pre + '<a href="' + url + '"' + attrsEnlace(url) + '>' + url.replace('https://', '') + '</a>';
    });

    // Correo y teléfono de la tienda, para tocar y contactar
    escaped = escaped.replace(/(^|[\s(])((?:info|pedidos)@agranelmadrid\.com)/g, '$1<a href="mailto:$2">$2</a>');
    escaped = escaped.replace(/(^|[\s(])(711 292 081)/g, '$1<a href="tel:+34711292081">$2</a>');

    // Negrita
    escaped = escaped.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');

    // Listas y párrafos
    var lineas = escaped.split('\n');
    var html = '';
    var enLista = false;
    var parrafo = [];

    function cerrarParrafo() {
      if (parrafo.length) {
        html += '<p>' + parrafo.join(' ') + '</p>';
        parrafo = [];
      }
    }

    lineas.forEach(function (linea) {
      var trimmed = linea.trim();
      if (/^[-•]\s+/.test(trimmed)) {
        cerrarParrafo();
        if (!enLista) {
          html += '<ul>';
          enLista = true;
        }
        html += '<li>' + trimmed.replace(/^[-•]\s+/, '') + '</li>';
      } else {
        if (enLista) {
          html += '</ul>';
          enLista = false;
        }
        if (trimmed === '') {
          cerrarParrafo();
        } else {
          parrafo.push(trimmed);
        }
      }
    });
    if (enLista) html += '</ul>';
    cerrarParrafo();

    return html || '<p></p>';
  }

  // ---- Mensajes ----
  function pintarMensaje(tipo, texto) {
    var div = document.createElement('div');
    div.className = 'ag-chat__msg ag-chat__msg--' + tipo;
    div.innerHTML = renderMarkdown(texto);
    log.appendChild(div);
    scrollAbajo();
    return div;
  }

  function pintarTyping() {
    var div = document.createElement('div');
    div.className = 'ag-chat__msg ag-chat__msg--bot';
    div.innerHTML = '<span class="ag-chat__typing"><span></span><span></span><span></span></span>';
    log.appendChild(div);
    scrollAbajo();
    return div;
  }

  function pintarTarjetas(items) {
    if (!items || !items.length) return;
    var grid = document.createElement('div');
    grid.className = 'ag-chat__cards';
    items.forEach(function (item) {
      if (!item || !item.url || !urlPermitida(item.url)) return;
      var a = document.createElement('a');
      a.className = 'ag-chat__card';
      a.href = item.url;
      if (!esInterna(item.url)) {
        a.target = '_blank';
        a.rel = 'noopener';
      }

      if (item.image) {
        var img = document.createElement('img');
        img.loading = 'lazy';
        img.alt = '';
        img.src = item.image;
        a.appendChild(img);
      }

      var body = document.createElement('div');
      body.className = 'ag-chat__card-body';

      var titulo = document.createElement('p');
      titulo.className = 'ag-chat__card-titulo';
      titulo.textContent = item.title || '';
      body.appendChild(titulo);

      var precio = document.createElement('p');
      if (item.available === false) {
        precio.className = 'ag-chat__card-precio ag-chat__card-precio--agotado';
        precio.textContent = 'Agotado';
      } else {
        precio.className = 'ag-chat__card-precio';
        // El Worker manda «2.85 €»; en la tienda los precios van con coma.
        precio.textContent = item.price_from ? 'desde ' + String(item.price_from).replace(/(\d)\.(\d{2})(?!\d)/, '$1,$2') : '';
      }
      body.appendChild(precio);

      a.appendChild(body);
      grid.appendChild(a);
    });
    log.appendChild(grid);
    scrollAbajo();
  }

  function scrollAbajo() {
    log.scrollTop = log.scrollHeight;
  }

  // ---- Abrir / cerrar ----
  function abrirPanel(sinFoco) {
    panel.hidden = false;
    fab.setAttribute('aria-expanded', 'true');
    safeSet(OPEN_KEY, '1');
    if (!sinFoco) input.focus();
  }

  function cerrarPanel(devolverFoco) {
    panel.hidden = true;
    fab.setAttribute('aria-expanded', 'false');
    safeSet(OPEN_KEY, '0');
    if (devolverFoco === true) fab.focus();
  }

  // En móvil el panel ocupa toda la pantalla: al ir a una ficha o a una página desde el chat,
  // la página nueva se abre con el chat cerrado (el historial se conserva). En escritorio sigue abierto.
  log.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || !esInterna(a.getAttribute('href'))) return;
    if (window.matchMedia && window.matchMedia('(max-width: 640px)').matches) safeSet(OPEN_KEY, '0');
  });

  fab.addEventListener('click', function () {
    if (panel.hidden) {
      abrirPanel();
    } else {
      cerrarPanel();
    }
  });

  cerrar.addEventListener('click', function () {
    cerrarPanel(true);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) cerrarPanel(true);
  });

  if (sugerencias) {
    sugerencias.querySelectorAll('.ag-chat__chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        input.value = chip.textContent;
        sugerencias.style.display = 'none';
        enviar();
      });
    });
  }

  // ---- Textarea ----
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      enviar();
    }
  });

  input.addEventListener('input', function () {
    input.style.height = 'auto';
    input.style.height = input.scrollHeight + 'px';
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    enviar();
  });

  // ---- Envío ----
  function enviar() {
    var texto = input.value.trim();
    if (!texto || enviando) return;

    if (sugerencias) sugerencias.style.display = 'none';
    pintarMensaje('user', texto);
    input.value = '';
    input.style.height = 'auto';

    enviando = true;
    enviarBtn.disabled = true;

    var typingEl = pintarTyping();
    var answer = '';
    var respondioTexto = false;

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message: texto, history: history }),
    })
      .then(function (res) {
        if (!res.ok) {
          return res
            .json()
            .catch(function () {
              return null;
            })
            .then(function (data) {
              throw new Error((data && data.error) || 'Ahora mismo no puedo responder.');
            });
        }
        var reader = res.body.getReader();
        var decoder = new TextDecoder();
        var buffer = '';

        function leer() {
          return reader.read().then(function (result) {
            if (result.done) return;
            buffer += decoder.decode(result.value, { stream: true });
            var partes = buffer.split('\n\n');
            buffer = partes.pop() || '';
            partes.forEach(procesarEvento);
            return leer();
          });
        }

        function procesarEvento(parte) {
          var linea = parte.split('\n').filter(function (l) {
            return l.indexOf('data: ') === 0;
          })[0];
          if (!linea) return;
          var ev;
          try {
            ev = JSON.parse(linea.slice(6));
          } catch (e) {
            return;
          }
          if (ev.type === 'text') {
            answer += ev.delta;
            respondioTexto = true;
            typingEl.innerHTML = renderMarkdown(answer);
            scrollAbajo();
          } else if (ev.type === 'products') {
            pintarTarjetas(ev.items);
          } else if (ev.type === 'error') {
            typingEl.className = 'ag-chat__msg ag-chat__msg--bot ag-chat__msg--error';
            typingEl.innerHTML = renderMarkdown(ev.message || 'Ahora mismo no puedo responder.');
            answer = ev.message || answer;
          }
        }

        return leer();
      })
      .then(function () {
        if (!respondioTexto && !answer) {
          typingEl.innerHTML = renderMarkdown('Ahora mismo no puedo responder. Escríbenos a info@agranelmadrid.com.');
          answer = 'Ahora mismo no puedo responder. Escríbenos a info@agranelmadrid.com.';
        }
        history.push({ role: 'user', content: texto });
        history.push({ role: 'assistant', content: answer });
        saveHistory();
      })
      .catch(function (err) {
        typingEl.className = 'ag-chat__msg ag-chat__msg--bot ag-chat__msg--error';
        typingEl.innerHTML = renderMarkdown(err.message || 'Ahora mismo no puedo responder.');
        console.error('ag-chat', err);
      })
      .finally(function () {
        enviando = false;
        enviarBtn.disabled = false;
        scrollAbajo();
      });
  }

  // ---- Init ----
  loadHistory();
  if (history.length) {
    if (sugerencias) sugerencias.style.display = 'none';
    repintarHistorial();
  }
  if (safeGet(OPEN_KEY) === '1') abrirPanel(true); // fix: no robar el foco al recargar
})();
